// extracted by mini-css-extract-plugin
module.exports = {"button":"MenuButton__button___XiCXr","active":"MenuButton__active___3O-YD","hideFocus":"MenuButton__hideFocus___3NuTx"};